import { isEmpty } from 'underscore';
import useGetShoppingCartQuery from '../../../../queries/useGetShoppingCartQuery';
import useAuthStore from '../../../../store/authStore';

interface CheckoutEligibilityProps {
  checkPolicy: boolean;
  emptyPrice: boolean;
}

export default function useCheckoutEligibility({
  checkPolicy,
  emptyPrice,
}: CheckoutEligibilityProps) {
  const user = useAuthStore((state) => state.user);
  const userProfile = useAuthStore((state) => state.userProfile);

  const { data } = useGetShoppingCartQuery();
  const shoppingItems = data?.shoppingItems;

  const enableCheckout =
    checkPolicy && userProfile !== undefined && !emptyPrice;

  const isNoUserOrCartEmpty = isEmpty(user) || isEmpty(shoppingItems);

  const isCheckoutDisabled = isNoUserOrCartEmpty || !enableCheckout;
  return { isCheckoutDisabled };
}
